export default [
  {
    path: 'compras',
    name: 'Resgates de compras',
    component: () => import('@containers/Purchase/PurchaseList'),
    title: 'Compras',
    icon: 'Shopping-Cart'
  },
  {
    path: 'codigos',
    name: 'Resgates de códigos únicos',
    component: () => import('@containers/UniqueCode/UniqueCodeList'),
    title: 'Códigos únicos',
    icon: 'scaner-barcode-select'
  },
  {
    path: 'vouchers',
    name: 'Resgates com voucher',
    component: () => import('@containers/Voucher/VoucherList'),
    title: 'Vouchers',
    icon: 'receipt'
  },
  {
    path: 'cartas',
    name: 'Resgates de cartas vínculo',
    component: () => import('@containers/Letter/LetterList'),
    title: 'Cartas vínculo',
    icon: 'certificate-medal'
  },
  {
    path: 'cashback',
    name: 'Resgates com dinheiro de volta',
    component: () => import('@containers/Cashback/CashbackList'),
    title: 'Cashback',
    icon: 'dollar-payments-conversion',
    permission: 'cashback_tab'
  }
]



// WEBPACK FOOTER //
// ./src/router/transaction.js